import { Modal, Form, Icon, Input, Typography } from 'antd'
import React from 'react'
import LoadingButton from 'src/components/styled/LoadingButton'

const { Item } = Form

const RegisterAccountForm = ({ submit, form, loading, error, accounts }) => {
  const { getFieldDecorator } = form

  const handleSubmit = () => {
    form.validateFields((validationError, values) => {
      if (!validationError) {
        submit({
          ...values,
          email: values.email.toLowerCase(),
        })
      } else {
        console.log('Validation Error', validationError)
      }
    })
  }

  // Custom email validator
  const validateEmail = (rule, value, callback) => {
    if (value) {
      const emailExists = accounts.some(
        account => account.emailAddress?.toLowerCase() === value.toLowerCase(),
      )
      if (emailExists) {
        callback('This email already exists. Please assign it to a venue.')
      } else {
        callback()
      }
    } else {
      callback()
    }
  }

  // Custom password validator
  const validatePassword = (rule, value, callback) => {
    if (!value) {
      callback('Please enter a password')
    } else if (value.length < 8) {
      callback('Password must be at least 8 characters')
    } else if (!/\d/.test(value)) {
      callback('Password must include at least one number')
    } else {
      callback()
    }
  }

  return (
    <Form
      onSubmit={event => {
        event.preventDefault()
        if (!loading) {
          handleSubmit()
        }
      }}
    >
      {error && (
        <Typography.Text
          type='danger'
          style={{ display: 'block', marginBottom: 16 }}
        >
          {error}
        </Typography.Text>
      )}

      <Item>
        {getFieldDecorator('name', {
          rules: [
            { required: true, message: 'Please input the account holder name' },
          ],
        })(
          <Input
            prefix={<Icon type='smile' style={{ color: 'rgba(0,0,0,.25)' }} />}
            placeholder='Full name (e.g. Jane Smith)'
            disabled={loading}
            autoFocus
          />,
        )}
      </Item>

      <Item>
        {getFieldDecorator('email', {
          rules: [
            { required: true, message: 'Please input an email address' },
            { type: 'email', message: 'Please enter a valid email address' },
            { validator: validateEmail },
          ],
        })(
          <Input
            prefix={<Icon type='user' style={{ color: 'rgba(0,0,0,.25)' }} />}
            placeholder='Email address (e.g. jane@example.com)'
            disabled={loading}
          />,
        )}
      </Item>

      <Item>
        {getFieldDecorator('password', {
          rules: [{ validator: validatePassword }],
        })(
          <Input.Password
            prefix={<Icon type='lock' style={{ color: 'rgba(0,0,0,.25)' }} />}
            placeholder='Password (min 8 chars, include a number)'
            disabled={loading}
          />,
        )}
      </Item>

      <Item style={{ marginBottom: 0 }}>
        <LoadingButton
          type='primary'
          htmlType='submit'
          loading={loading}
          style={{ width: '100%' }}
        >
          Create account
        </LoadingButton>
      </Item>
    </Form>
  )
}

const WrappedRegisterAccountForm = Form.create({ name: 'register_account' })(
  RegisterAccountForm,
)

const RegisterAccountModal = ({
  visible,
  onCancel,
  onSubmit,
  loading,
  error,
  accounts,
}) => {
  return (
    <Modal
      title='Register account'
      visible={visible}
      onCancel={onCancel}
      footer={null}
      width={500}
      maskClosable={!loading}
      closable={!loading}
      keyboard={!loading}
    >
      <WrappedRegisterAccountForm
        submit={onSubmit}
        loading={loading}
        error={error}
        accounts={accounts}
      />
    </Modal>
  )
}

export default RegisterAccountModal
